<template>
    <div class="place-detail">
        <ul class="nav nav-tabs">
            <li class="nav-item"><a class="active" data-toggle="tab" href="#fromstart">Điểm đón</a></li>
            <li class="nav-item"><a data-toggle="tab" href="#toend">Điểm trả</a></li>
            <li class="nav-item" v-if="schedule_type === scheduleTypes.CAN_SELECT_SEATS"><a data-toggle="tab" href="#select-seat">Chọn chỗ</a></li>
        </ul>
        <div class="tab-content tab-content-place pt-3">
            <div id="fromstart" class="tab-pane fade show active">
                <div class="place-height">
                    <div class="pb-1 pr-0 form-group pickup" v-for="(pickup, key) in v.pickupLocations.$each.$iter" :key="key">
                        <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Điểm đón và số người đón<span style="color:red;">*</span>:</label>
                        <div class="location-group">
                            <selector-place class="select-pickup"
                                            :value="pickup.address.$model"
                                            :voyage_id="voyage_id"
                                            order="asc"
                                            @input="pickup.$model = {...$event, people_quantity: pickup.people_quantity.$model}; pickup.address.$model = getProp($event, 'address', '')">
                            </selector-place>
                            <input type="number"
                                   class="form-control input-vxr ml-1 people-quantity-pickup"
                                   :value="pickup.people_quantity.$model"
                                   @input="onInput($event, pickup)"
                                   placeholder="Số lượng">

                            <img v-if="key !== '0'"
                                 @click="removeItemLocation('pickup', key)"
                                 class="ml-1 btn-minus" src="../../../../assets/images/minus-icon.svg" alt="">
                        </div>
                        <div v-if="pickup.address.$error || pickup.people_quantity.$error">
                            <span class="error" v-if="!pickup.address.required">Điểm đón không được để trống</span>
                            <span class="error" v-if="!pickup.people_quantity.minValue">Số lượng người đón phải lớn hơn 1</span>
                            <span class="error" v-if="!pickup.people_quantity.required">Số lượng không được để trống</span>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary btn-plus" @click="addItemLocation('pickup')">Thêm điểm đón</button>
                    </div>
                </div>
            </div>
            <div id="toend" class="tab-pane fade">
                <div class="place-height">
                    <div class="pb-1 pr-0 form-group" v-for="(getOff, key) in v.getOffLocations.$each.$iter" :key="key">
                        <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Điểm trả<span style="color:red;">*</span>:</label>
                        <div class="location-group position-relative">
                          <selector-place class="input-get-off"
                                          :value="getOff.address.$model"
                                          :voyage_id="voyage_id"
                                          order="desc"
                                          @input="getOff.$model = {...$event}; getOff.address.$model = getProp($event, 'address', '')"
                                          :to-text="getOffAddressParser"
                          >
                          </selector-place>
<!--                            <input type="text"-->
<!--                                   class="form-control input-vxr input-get-off"-->
<!--                                   placeholder="Nhập điểm trả"-->
<!--                                   :value="getOff.address.$model"-->
<!--                                   @input="getOff.address.$model = $event.target.value; getOff.$model = {...{}, address: $event.target.value}">-->

                            <img v-if="key !== '0'"
                                 @click="removeItemLocation('getOff', key)"
                                 class="ml-1 btn-minus" src="../../../../assets/images/minus-icon.svg" alt="">
                        </div>

                        <div v-if="getOff.address.$error">
                            <span class="error" v-if="!getOff.address.required">Điểm trả không được để trống</span>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary btn-plus" @click="addItemLocation('getOff')">Thêm điểm trả</button>
                    </div>
                </div>
            </div>
            <div id="select-seat" class="tab-pane fade">
              <slot name="seat-map"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { SelectorPlace } from "../../../shared/components";
    import {MixinHelper} from "../../../shared/services";
    import get from "lodash/get";
    import {SCHEDULE_TYPE} from "@/app/shared/constants/Constant";

    export default {
        name: "PlaceDetail",
        mixins: [MixinHelper],
        components: {SelectorPlace},
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        pickupLocations: [],
                        getOffLocations: []
                    }
                }
            },
            ticket_price_common: {
              type: Number,
              default: 0
            },
            v: {
                type: Object,
                required: true
            },
            voyage_id: {
              type: Number,
              default: null,
            },
            schedule_type: {
              type: Number,
              default: SCHEDULE_TYPE.NOT_SELECT_SEATS,
            }
        },
        data() {
          return {
            scheduleTypes: SCHEDULE_TYPE,
          }
        },
        created() {
            // this.addPickup();
          this.calPrice();
        },
        methods: {
            emitVal() {
              this.$emit('input', this.value);
            },
            calPrice() {
              const iter = Object.values(this.v.pickupLocations.$each.$iter);
              let totalQuantity = 0;
              for (const o of iter) {
                totalQuantity += o.people_quantity.$model;
              }

              const totalPrice = this.ticket_price_common * totalQuantity;

              this.$emit('totalPrice', totalPrice);
            },
            onInput($event, pickup) {
              const quantity = Number($event.target.value) || 0;
              pickup.people_quantity.$model = quantity;
              pickup.$model = {...pickup.$model, people_quantity: quantity};
              this.calPrice();
            },
            getOffAddressParser(item) {
              const ward = get(item, 'ward._name', '');
              return get(item, 'street._name', '') + (ward ? ` - ${ward}` : '');
            },
        },
        watch: {
          ticket_price_common() {
            this.calPrice();
          }
        }
    }
</script>

<style scoped>
    .place-detail .nav-tabs li {
        float: left;
        margin-bottom: -1px;
        width: 50%;
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        border-radius: 5px 5px 0 0;
    }

    .place-detail .nav-tabs li a.active {
        color: #333;
        cursor: default;
        background-color: #fff;
        border: 1px solid #eee;
        border-bottom-color: transparent;
        border-radius: 5px 5px 0 0;
        border-top: 4px solid #1867BC;
    }

    .nav > li > a {
        padding: 10px 15px;
        color: #8C8C8C;
        width: 100%;
        display: block;
        position: relative;
    }

    li {
        list-style: none;
    }

    a:hover {
        text-decoration: none;
    }

    .pickup {
        position: relative;
    }

    .place-height {
        height: 200px;
    }
    .location-group {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
    }
    .people-quantity-pickup {
        width: 20%;
        height: 40px;
        font-size: 12px;
    }
    input.people-quantity-pickup:focus {
        outline: none !important;
    }
    .location-group .select-pickup {
        width: 68%;
    }
    .btn-plus {
        font-size: 14px;
    }
    .tab-content-place {
        overflow-y: scroll;
    }
    .location-group .input-get-off {
        width: 90%;
    }
    .btn-minus {
        cursor: pointer;
        width: 5%;
        background-color: #fff;
        border: none
    }
</style>
